import wsIO from '../services/socket'

// from @webtrit/webtrit-signaling
// export enum EventType {
//   Session = 'session',
//   OutgoingCall = 'out',
//   IncomingCall = 'in',
//   AcceptedCall = 'ans',
//   HangupCall = 'hangup',
//   Line = 'line',
//   ChangeCall = 'change',
//   Processing = 'skip',
//   Notify = 'notify'
// }

const getEventHandlers = () => ({
  session: {
    registering: () => {},
    unregistering: () => {},
    unregistered(event, login, auth) {
      wsIO.emit('events', login, 'unregistered', auth)
    },
    registered(event, login, auth) {
      wsIO.emit('events', login, 'registered', auth)
    },
  },
  in: {
    incoming_call(event, login) {
      wsIO.emit('events', login, event.event, '', event.call_id, event.callee)
    },
  },
  ans: {
    accepted(event, login, _, dispatch) {
      const callId = event.call_id
      if (callId) {
        dispatch('leadLists/setCurrentCallId', callId, { root: true })
      } else {
        console.log(`event without callId: ${JSON.stringify(event)}`)
      }
      wsIO.emit('events', login, event.event, '', event.call_id, event.callee)
    },
  },
  out: {
    calling(event, login) {
      wsIO.emit('events', login, event.event, '', event.call_id, event.callee)
    },
  },
  hangup: {
    hangup(event, login) {
      wsIO.emit('events', login, event.event, '', event.call_id, event.callee)
    },
  },
})

export default {
  namespaced: true,
  actions: {
    handleWebtritEvent({ dispatch, rootGetters }, { event }) {
      const login = rootGetters['account/login']
      const auth = rootGetters['account/token']
      const handlers = getEventHandlers()[event.type]
      if (handlers && handlers[event.event]) {
        handlers[event.event](event, login, auth, dispatch)
      }
    },

    disconnect() {
      console.log('------DISCONNECTING TO SOCKET------')
      wsIO.removeAllListeners()
      wsIO.disconnect()
    },

    async connect({ rootGetters }) {
      const token = rootGetters['account/token']
      const login = rootGetters['account/login']
      console.log('------CONNECTING TO SOCKET------')
      wsIO.on('reqStatus', () => {
        console.log('------REQ STATUS------', login, token, rootGetters['account/info'].name)
        const registered = rootGetters['webrtc/isRegistered']
        wsIO.emit('events', login, 'set_account_info', token, '', '', rootGetters['account/info'].name)
        if (registered) {
          wsIO.emit('events', login, 'registered', token)
        } else {
          wsIO.emit('events', login, 'unregistered', token)
        }
      })
      wsIO.connect({ token, login })
    },

    handleUnregister({ rootGetters }) {
      console.log('------HANDLE UNREGISTERED------')
      const login = rootGetters['account/login']
      const auth = rootGetters['account/token']
      wsIO.emit('events', login, 'unregistered', auth)
    },
    setAccountInfo(context, data) {
      console.log('------SET ACCOUNT INFO------', data.agentId, context.rootGetters['account/token'], data.agentName)
      if (data.agentId) {
        wsIO.emit('events', data.agentId, 'set_account_info', '', '', '', data.agentName)
      }
    },
  },
}
